import {RefObject, useEffect} from 'react';

/**
 * Smoothly scrolls the referenced element into view when `active` flips to true.
 * Used for panels/sections that render lower in the page (e.g. behind a sticky
 * header or below other panels) so it's clear they appeared when toggled on.
 *
 * The element should set `scrollMarginTop` to clear any sticky header.
 */
export function useScrollIntoViewOnActivate<T extends HTMLElement>(
    ref: RefObject<T>,
    active: boolean,
): void {
    useEffect(() => {
        if (!active) return undefined;
        const id = requestAnimationFrame(() => {
            ref.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
        return (): void => cancelAnimationFrame(id);
    }, [active, ref]);
}
